import { listSizesConfig } from "./listSizesConfig";
import { listItemSizesConfig } from "./listItemSizesConfig";
import { dtSizesConfig } from "./dtSizesConfig";
export var listPortalTokens = {
  listSizes: listSizesConfig,
  listItemSizes: listItemSizesConfig,
  dtSizes: dtSizesConfig,
  defaultUlMarker: "dash",
  ulMarkers: {
    dash: {
      style: "'\\2014'",
      gap: "0.3em"
    },
    bullet: {
      style: "'\\2022'",
      gap: "0.55em"
    },
    none: {
      style: "none",
      gap: 0
    }
  },
  dl: {
    termColumnWidth: "6em",
    marginRight: "1.2em"
  },
  ol: {
    markerGap: "0.3em"
  },
  nestedListPt: "0.5em",
  lineHeight: "150%"
};